type UndoButtonProps = {
  title: string;
  onUndo: () => void;
  disabled?: boolean;
};

export const UndoButton = ({ title, onUndo, disabled }: UndoButtonProps) => (
  <button
    type="button"
    disabled={disabled}
    title={title}
    aria-label={title}
    onMouseDown={(event) => event.preventDefault()}
    onClick={(event) => {
      event.stopPropagation();
      onUndo();
    }}
    className="inline-flex size-5 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-gray-50 text-gray-700 hover:bg-gray-100 disabled:opacity-50"
  >
    <i className="pi pi-undo text-[10px]" />
  </button>
);
